(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const motionEnabled = () => document.body.dataset.fangMotion === 'true' && !reduced.matches;
  class FangNavigation extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-fang-menu-open]');
      this.previousOverflow = '';
      const sync = () => this.classList.toggle('is-solid', window.scrollY > 40);
      sync();
      window.addEventListener('scroll', sync, { passive: true, signal });
      this.querySelectorAll('a[href]').forEach(a => {
        const url = new URL(a.href, location.origin);
        if (url.origin === location.origin && url.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')) a.setAttribute('aria-current', 'page');
      });
      this.trigger?.addEventListener('click', () => {
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        this.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }, { signal });
      this.querySelector('[data-fang-menu-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog?.addEventListener('click', e => {
        const box = this.dialog.getBoundingClientRect();
        if (e.target === this.dialog && (e.clientX < box.left || e.clientX > box.right)) this.dialog.close();
      }, { signal });
      this.dialog?.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow;
        this.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.focus({ preventScroll: true });
      }, { signal });
      window.addEventListener('resize', () => { if (innerWidth >= 768 && this.dialog?.open) this.dialog.close(); }, { signal });
    }
    disconnectedCallback() {
      if (this.dialog?.open) document.body.style.overflow = this.previousOverflow;
      this.controller?.abort();
    }
  }
  if (!customElements.get('fang-navigation')) customElements.define('fang-navigation', FangNavigation);
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fang-reveal-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  const parallax = new Set();
  let frame = 0;
  function updateParallax() {
    frame = 0;
    parallax.forEach(host => {
      if (!host.isConnected) { parallax.delete(host); return; }
      const box = host.getBoundingClientRect();
      if (box.bottom < -100 || box.top > innerHeight + 100) return;
      const progress = Math.max(0, Math.min(1, (innerHeight - box.top) / (innerHeight + box.height)));
      host.style.setProperty('--fang-parallax-y', motionEnabled() ? `${-56 + progress * 112}px` : '0px');
    });
  }
  function scheduleParallax() { if (!frame) frame = requestAnimationFrame(updateParallax); }
  window.addEventListener('scroll', scheduleParallax, { passive: true });
  window.addEventListener('resize', scheduleParallax, { passive: true });
  function setup(root = document) {
    root.querySelectorAll('[data-fang-reveal]').forEach(el => {
      if (el.dataset.fangReady) return;
      el.dataset.fangReady = 'true';
      if (motionEnabled() && !window.Shopify?.designMode && revealObserver) {
        el.classList.add('fang-reveal-ready');
        revealObserver.observe(el);
      }
    });
    root.querySelectorAll('[data-fang-parallax]').forEach(el => parallax.add(el));
    root.querySelectorAll('[data-fang-catalog]').forEach(catalog => {
      if (catalog.dataset.fangReady) return;
      catalog.dataset.fangReady = 'true';
      catalog.addEventListener('click', event => {
        const button = event.target.closest('[data-fang-filter]');
        if (!button) return;
        const category = button.dataset.fangFilter;
        catalog.querySelectorAll('[data-fang-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        let visible = 0;
        catalog.querySelectorAll('[data-fang-product]').forEach(card => {
          const show = category === 'all' || card.dataset.category === category;
          card.hidden = !show;
          if (show) {
            visible++;
            if (motionEnabled()) card.animate([{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 500, easing: 'cubic-bezier(.16,1,.3,1)' });
          }
        });
        const empty = catalog.querySelector('[data-fang-empty]');
        if (empty) empty.hidden = visible > 0;
      });
    });
    scheduleParallax();
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-fang-reveal]').forEach(el => revealObserver?.unobserve(el));
    event.target.querySelectorAll('[data-fang-parallax]').forEach(el => parallax.delete(el));
  });
  document.addEventListener('shopify:section:select', event => {
    event.target.querySelectorAll('[data-fang-reveal]').forEach(el => el.classList.add('fang-reveal-visible'));
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) document.querySelectorAll('.fang-reveal-ready').forEach(el => el.classList.add('fang-reveal-visible'));
    scheduleParallax();
  });
  const curtain = document.querySelector('[data-fang-intro]');
  let seen = false;
  try { seen = sessionStorage.getItem('fang-intro') === '1'; } catch {}
  if (curtain && !seen && motionEnabled() && !window.Shopify?.designMode) {
    curtain.hidden = false;
    const before = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    setTimeout(() => curtain.classList.add('is-open'), 850);
    setTimeout(() => {
      curtain.hidden = true;
      if (!document.querySelector('fang-navigation dialog[open]')) document.body.style.overflow = before;
      try { sessionStorage.setItem('fang-intro', '1'); } catch {}
    }, 2100);
  }
})();
